import { Injectable } from '@angular/core';
import { ActiveOrderDsService } from '@app/core/data-services';
import { ProductionOrderPrintedLabelInfo } from 'chronos-core-client';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SetupParametersService {
  private printInfoBehaviorSubject = new BehaviorSubject<ProductionOrderPrintedLabelInfo>(null);
  public printInfo$ = this.printInfoBehaviorSubject.asObservable();

  constructor(private activeOrderDsService: ActiveOrderDsService) {}

  public getPrintInfoForAllLabels(): void {
    const productionOrderId: number = this.activeOrderDsService.getActiveOrderId();
    this.activeOrderDsService.getPrintedLabelInfoForSetupPhase(productionOrderId)
    .subscribe((printInfo) => {
      this.printInfoBehaviorSubject.next(printInfo);
    });
  }
}
